module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hx7Ew"))).then(() => parcelRequire('hEqeo'));